module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/campaigns/campaigns-create/campaigns-create.component.css
// module id = ./src/app/components/campaigns/campaigns-create/campaigns-create.component.css
// module chunks = main